<template>
  <div id="app">
    <div id="main">
      <router-view v-if="routing" />
      <FaqClientWrapper v-else />
    </div>
    <Multimodal />
  </div>
</template>

<script>
import Multimodal from '@/components/Multimodal';
import Const from './const';

export default {
  name: 'App',
  components: { Multimodal },
  data: () => {
    return { routing: Const.ROUTING };
  },
  async created() {
    await this.$store.dispatch('Initialize');
  },
};
</script>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  line-height: normal;
  font-size: 16px;
}
#app {
  button {
    border: none;
    cursor: pointer;
    &:focus {
      outline: none;
    }
  }
}
#app {
  margin: 0;
  overflow: visible;
  .mobile & {
    height: 100%;
  }
}
#main {
  a {
    text-decoration: none !important;
  }
  .mobile & {
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// products/390/App.vue